<template>
  <div
    id="main-div"
    :class="
      $route.meta.is_header == 'home' && company_code != 'airbnb'
        ? 'public-cls'
        : $route.meta.is_header == 'home' && company_code == 'airbnb'
        ? 'public-cls customer-a45'
        : $route.meta.is_header == 'admin' && company_code != 'airbnb'
        ? 'admin_dash_cls'
        : $route.meta.is_header == 'admin'
        ? 'admin_dash_cls airbnb'
        : $route.meta.is_header == 'airbnb'
        ? 'customer-a45'
        : company_code == 'airbnb' && $route.meta.is_header != 'login'
        ? 'user-site-cls airbnb'
        : 'user-site-cls'
    "
  >
    <fullpageloader ref="fullpageloader"></fullpageloader>
    <Header
      v-if="
        ($route.meta.is_header == 'user_dashboard' ||
          $route.meta.is_header == 'admin') &&
        company_code != 'airbnb'
      "
      ref="headercompnent"
    />
    <HeaderHome
      v-if="$route.meta.is_header == 'home'"
      ref="headercompnent"
    />
    <LoginHeader v-if="$route.meta.is_header == 'login'" />
    <HeaderAirbnb
      v-if="($route.meta.is_header == 'airbnb' || company_code == 'airbnb') && $route.meta.is_header != 'home'"
      ref="airbnbheadercompnent"
    />

    <div
      class="dashboard_section empdashboard-cls"
      v-if="
        ($route.meta.is_sidebar == 'employee-sidebar' ||
          $route.meta.is_sidebar == 'clientmanager-sidebar') &&
        $route.meta.is_header != 'admin' &&
        $route.meta.is_header != 'home' &&
        $route.meta.is_header == 'user_dashboard'
      "
    >
      <div class="container-fluid">
        <div class="row">
          <EmployeeSideBar
            v-if="$route.meta.is_sidebar == 'employee-sidebar'"
          />
          <MobileSidebar v-if="$route.meta.is_sidebar == 'employee-sidebar'"/>
          <ClientManagerSideBar
            v-if="$route.meta.is_sidebar == 'clientmanager-sidebar'"
          />
          <div class="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <main>
              <router-view :key="$route.path"></router-view>
            </main>
          </div>
        </div>
      </div>
    </div>
    <div
      class="dashboard_section"
      v-else-if="
        $route.meta.is_header == 'admin' &&
        $route.meta.is_header != 'home' &&
        $route.meta.is_header != 'user_dashboard'
      "
    >
      <div class="container-fluid">
        <div class="row">
          <SideBar />
          <router-view :key="$route.path"></router-view>
        </div>
      </div>
    </div>
    <main v-else>
      <router-view :key="$route.path"></router-view>
    </main>

    <Footer
      v-if="
        ($route.meta.is_header && company_code != 'airbnb' && $route.meta.is_header != 'logout') ||
        $route.meta.is_header == 'login'
      "
    />
    <FooterAirbnb
      v-if="
        ($route.meta.is_header == 'airbnb' || company_code == 'airbnb') &&
        $route.meta.is_header != 'login' && $route.meta.is_header != 'logout'
      "
    />
    
    <!-- Session Warning Modal -->
    <SessionWarningModal ref="sessionWarningModal" />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import HeaderHome from "./components/HeaderHome.vue";
import LoginHeader from "./components/LoginHeader.vue";
import EmployeeSideBar from "./components/EmployeeSideBar.vue";
import ClientManagerSideBar from "./components/ClientManagerSideBar.vue";
import SideBar from "./components/Sidebar.vue";
import Footer from "./components/Footer.vue";
import HeaderAirbnb from "./components/HeaderAirbnb.vue";
import FooterAirbnb from "./components/FooterAirbnb.vue";
import MobileSidebar from "./components/MobileSidebar.vue";
import SessionWarningModal from "./components/SessionWarningModal.vue";
import { applyThemeColors } from "./utils/helpers";
import { isPublicRoute } from "@/utils/routeUtils";


export default {
  name: "App",
  components: {
    LoginHeader,
    Header,
    EmployeeSideBar,
    ClientManagerSideBar,
    Footer,
    HeaderHome,
    SideBar,
    HeaderAirbnb,
    FooterAirbnb,
    MobileSidebar,
    SessionWarningModal
  },
  data() {
    const accessTokenTTL = parseInt(process.env.VUE_APP_JWT_TTL_MINUTES) || 30;
    // Warning time: Calculate based on JWT TTL
    // Show warning when 20% of session time remains, with minimum of 2 minutes
    // This ensures proportional warning time regardless of TTL configuration
    const warningTimeMinutes = Math.max(2, Math.floor(accessTokenTTL * 0.2));
    const idleTimeLimit = (accessTokenTTL - 1) * 60 * 1000; // Refresh token 1 min before expiration
    return {
      from: null,
      // company_code: null,
      main_div_class: "public-cls",
      idleTimeout: null,
      idleTimeLimit: idleTimeLimit,
      warningTimeLimit: idleTimeLimit - (warningTimeMinutes * 60 * 1000), // Time before showing warning
      warningTimeMinutes: warningTimeMinutes, // Minutes to show warning before expiration
      refreshInterval: 5 * 60 * 1000, // Refresh every 5 mins during activity
      lastActivityTime: Date.now(),
      warningTimer: null, // Timer to check if warning should be shown
      isWarningShown: false, // Track if warning modal is currently shown
      isExtendingSession: false, // Track if session extension is in progress
      lastWarningShowTime: 0, // Track when warning was last shown to prevent rapid reopening
      sessionExpirationTime: null, // Exact timestamp when session will expire (single source of truth)
      countdownUpdateInterval: null, // Interval to update countdown timer in real-time
    };
  },
  computed: {
    company_code() {
      let data = this.$store.getters["auth/authUser"];
      if(data != null ) {
        let company_data = data.client;
        if (company_data == null) {
          company_data = [];
        }
        if (company_data.length == 0 || company_data.length === "undefined") {
          return null;
        } else {
          return company_data.company_code.toLowerCase();
        }
      } else {
        return null;
      }
    },
    color_client() {
      let data = this.$store.getters["auth/authUser"];
      if(data == null)
        return null;

      return data.client;
      
    },
    /**
     * Computed property to track authentication state
     * Used by watcher to detect logout
     */
    isAuthenticated() {
      return this.isUserAuthenticated();
    }
  },
  watch: {
    /**
     * Watch authentication state - immediately close popup when user logs out
     */
    isAuthenticated(newVal, oldVal) {
      // If user just logged out (was authenticated, now not)
      if (oldVal && !newVal) {
        this.hideWarningModal();
        this.isWarningShown = false;
        this.isExtendingSession = false;
        this.clearAllTimers();
      }
      // If user just logged in (was not authenticated, now is)
      else if (!oldVal && newVal) {
        // Reset timers on login
        this.lastActivityTime = Date.now();
        this.lastWarningShowTime = 0;
        this.resetAllTimers();
      }
    },
    /**
     * Watch company color_client from Vuex store
     * Apply theme colors immediately when company information changes
     */
    color_client(newClient, oldClient) {
      // Only apply if client data actually changed and is not null
      if (newClient && newClient !== oldClient) {
        applyThemeColors(newClient);
      } else if (!newClient && oldClient) {
        // Reset to default colors when logged out
        applyThemeColors(null);
      }
    }
  },
  mounted() {
    document.title = "PBErgo | Ergonomics Training | Consulting | Consultant";
    setTimeout(() => {
      this.$refs.fullpageloader.is_full_page_loader = false;
    }, 50);
    
    // Initialize session expiration time if user is already logged in
    if (this.isUserAuthenticated()) {
      this.calculateSessionExpirationTime();
    }
    
    this.registerActivityListeners();
    this.startIdleTimer();
    this.startBackgroundTokenRefresh();
    this.setupMultiTabSync();
    
    // Listen for localStorage changes (multi-tab support for theme)
    // This ensures theme updates when companyInformation changes in other tabs
    this.storageThemeHandler = (e) => {
      if (e.key === "companyInformation") {
        // Apply theme colors when companyInformation changes in localStorage
        applyThemeColors();
      }
    };
    window.addEventListener("storage", this.storageThemeHandler);
    
    // Also listen for same-tab localStorage changes using a custom event
    // (storage event only fires for other tabs, not the current tab)
    this.localStorageThemeHandler = () => {
      applyThemeColors(null, false);
    };
    // Use a custom event dispatched when localStorage is set
    window.addEventListener("companyInformationUpdated", this.localStorageThemeHandler);
    
    // Apply theme on mount if companyInformation exists
    if (this.color_client) {
      applyThemeColors(this.color_client);
    } else {
      // Fallback to localStorage if Vuex store doesn't have it yet
      applyThemeColors();
    }
  },
  methods: {
    startBackgroundTokenRefresh() {
      window.tokenRefreshInterval = setInterval(async () => {
        const now = Date.now();

        // 🚫 Skip refresh on public pages
        if (isPublicRoute()) {
          return;
        }

        // Only refresh if the user was active within the last idleTimeLimit
        if (now - this.lastActivityTime < this.idleTimeLimit) {
          try {
            await this.$store.dispatch("auth/refreshToken");
          } catch (error) {
            await this.$store.dispatch("auth/logout");
          }
        } else {
          console.log("Skipping token refresh due to user inactivity");
        }
      }, this.refreshInterval); // every 5 mins (adjustable)
    },

    resetIdleTimer() {
      // Don't reset timer if we're currently extending session (waiting for token refresh)
      if (this.isExtendingSession) {
        return;
      }

      this.lastActivityTime = Date.now();
      // Recalculate expiration time when user becomes active
      this.calculateSessionExpirationTime();
      
      // If warning modal is shown and user becomes active, hide it and reset timers
      // But only if user is authenticated and not in the process of extending session
      if (this.isWarningShown && this.isUserAuthenticated()) {
        this.hideWarningModal();
        this.resetAllTimers();
        // Broadcast session extension to other tabs
        this.broadcastSessionExtension();
      }
    },

    registerActivityListeners() {
      const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"];
      events.forEach((event) => {
        window.addEventListener(event, this.resetIdleTimer);
      });
    },

    /**
     * Calculate and set the exact session expiration time
     * This is the single source of truth for when the session will expire
     * Based on lastActivityTime + idleTimeLimit to ensure accurate countdown
     */
    calculateSessionExpirationTime() {
      // Session expires idleTimeLimit milliseconds after last activity
      this.sessionExpirationTime = this.lastActivityTime + this.idleTimeLimit;
    },

    /**
     * Get the exact remaining time until session expiration in milliseconds
     */
    getRemainingTime() {
      if (!this.sessionExpirationTime) {
        this.calculateSessionExpirationTime();
      }
      const now = Date.now();
      const remaining = this.sessionExpirationTime - now;
      return Math.max(0, remaining);
    },

    /**
     * Start the idle timer that checks for user inactivity
     * Uses precise timing based on sessionExpirationTime for synchronization
     */
    startIdleTimer() {
      // Calculate initial expiration time
      this.calculateSessionExpirationTime();
      
      // Check more frequently (every second) when warning is shown for precision
      // Otherwise check every 10 seconds to reduce overhead
      const checkInterval = this.isWarningShown ? 1000 : 10000;
      
      window.idleTimeout = setInterval(() => {
        // Only check if user is authenticated
        if (!this.isUserAuthenticated()) {
          this.hideWarningModal();
          return;
        }

        const remainingTime = this.getRemainingTime();
        const remainingSeconds = Math.floor(remainingTime / 1000);
        
        // If session has expired, logout immediately
        if (remainingTime <= 0) {
          this.handleSessionExpiration();
          return;
        }

        // Calculate time until warning should show
        const warningTimeMs = this.warningTimeMinutes * 60 * 1000;
        const timeUntilWarning = remainingTime - warningTimeMs;
        
        // Prevent popup from reopening too quickly (within 10 seconds of last show)
        const now = Date.now();
        const timeSinceLastWarning = now - this.lastWarningShowTime;
        const shouldShowWarning = timeSinceLastWarning > 10 * 1000; // 10 seconds cooldown
        
        // If we're within warning time and not already showing, show warning
        if (timeUntilWarning <= 0 && !this.isWarningShown && shouldShowWarning && !this.isExtendingSession) {
          this.showWarningModal();
        }
        
        // Update countdown in modal if it's shown (synchronize with actual expiration time)
        if (this.isWarningShown && this.$refs.sessionWarningModal) {
          this.$refs.sessionWarningModal.updateTimeRemaining(remainingSeconds);
        }
      }, checkInterval);
    },

    /**
     * Show the session warning modal with countdown
     * Only shows if user is authenticated
     * Uses sessionExpirationTime as single source of truth for countdown
     */
    showWarningModal() {
      // Check if user is authenticated before showing modal
      if (!this.isUserAuthenticated()) {
        this.hideWarningModal();
        return;
      }

      if (this.isWarningShown) {
        return; // Already showing
      }

      this.isWarningShown = true;
      this.lastWarningShowTime = Date.now();
      
      // Ensure expiration time is calculated
      if (!this.sessionExpirationTime) {
        this.calculateSessionExpirationTime();
      }
      
      // Calculate remaining time from single source of truth
      const remainingTime = this.getRemainingTime();
      const warningTimeSeconds = Math.max(0, Math.floor(remainingTime / 1000));

      // Show modal with countdown
      if (this.$refs.sessionWarningModal) {
        this.$refs.sessionWarningModal.show(
          warningTimeSeconds,
          this.handleContinueSession, // Continue callback
          this.handleSessionExpiration // Logout callback
        );
      }
      
      // Switch to more frequent checks when modal is shown for precision
      this.restartIdleTimerWithPrecision();
      
      // Immediately update countdown to ensure it's accurate (don't wait for first interval tick)
      // This ensures the countdown starts correctly from the moment modal is shown
      if (this.$refs.sessionWarningModal) {
        this.$refs.sessionWarningModal.updateTimeRemaining(warningTimeSeconds);
      }
    },

    /**
     * Hide the session warning modal
     */
    hideWarningModal() {
      this.isWarningShown = false;
      if (this.$refs.sessionWarningModal) {
        this.$refs.sessionWarningModal.close();
      }
    },

    /**
     * Handle when user clicks "Continue" in the warning modal
     * Resets the session timer and refreshes the token
     * Modal will only close when session extends successfully or user becomes unauthenticated
     */
    async handleContinueSession() {
      // Check if user is still authenticated
      if (!this.isUserAuthenticated()) {
        this.hideWarningModal();
        return;
      }

      this.isExtendingSession = true;
      
      try {
        // Refresh token to extend session
        await this.$store.dispatch("auth/refreshToken");
        // console.log("Session extended successfully");
        
        // Reset activity time and recalculate expiration time
        this.lastActivityTime = Date.now();
        this.calculateSessionExpirationTime();
        
        // Only close modal and reset timers after successful token refresh
        this.isWarningShown = false;
        this.isExtendingSession = false;
        this.hideWarningModal();
        this.resetAllTimers();
        
        // Broadcast session extension to other tabs
        this.broadcastSessionExtension();
      } catch (error) {
        console.error("Failed to refresh token:", error);
        this.isExtendingSession = false;
        // If refresh fails, logout (this will also close the modal)
        await this.handleSessionExpiration();
      }
    },

    /**
     * Handle session expiration - logout the user
     */
    async handleSessionExpiration() {
      // Immediately close popup
      this.hideWarningModal();
      this.isWarningShown = false;
      this.isExtendingSession = false;
      this.clearAllTimers();
      this.sessionExpirationTime = null;
      
      // Show logout toast notification
      if (this.$toast) {
        this.$toast.error("You have been logged out.", {
          position: "top-right",
        });
      }
      
      // Broadcast logout to other tabs (this will close popup in all tabs)
      this.broadcastLogout();
      
      await this.$store.dispatch("auth/logout");
    },

    /**
     * Reset all timers when user activity is detected
     */
    resetAllTimers() {
      // Clear existing timers
      this.clearAllTimers();
      
      // Recalculate expiration time
      this.calculateSessionExpirationTime();
      
      // Restart timers
      this.startIdleTimer();
      this.startBackgroundTokenRefresh();
    },

    /**
     * Restart idle timer with precision (1 second checks) when modal is shown
     */
    restartIdleTimerWithPrecision() {
      // Clear existing timer
      if (window.idleTimeout) {
        clearInterval(window.idleTimeout);
        window.idleTimeout = null;
      }
      
      // Restart with 1 second precision (startIdleTimer will detect isWarningShown and use 1s interval)
      this.startIdleTimer();
      
      // Immediately update countdown once to ensure it's accurate from the start
      // (don't wait for first interval tick which could be up to 1 second away)
      if (this.isWarningShown && this.$refs.sessionWarningModal) {
        const remainingTime = this.getRemainingTime();
        const remainingSeconds = Math.floor(remainingTime / 1000);
        this.$refs.sessionWarningModal.updateTimeRemaining(remainingSeconds);
      }
    },

    /**
     * Clear all intervals and timers
     */
    clearAllTimers() {
      if (window.idleTimeout) {
        clearInterval(window.idleTimeout);
        window.idleTimeout = null;
      }
      if (window.tokenRefreshInterval) {
        clearInterval(window.tokenRefreshInterval);
        window.tokenRefreshInterval = null;
      }
      if (this.warningTimer) {
        clearTimeout(this.warningTimer);
        this.warningTimer = null;
      }
    },

    /**
     * Check if user is authenticated
     */
    isUserAuthenticated() {
      return this.$store.getters["auth/loggedIn"] && this.$store.getters["auth/authUser"] !== null;
    },

    /**
     * Setup multi-tab session synchronization using localStorage events
     */
    setupMultiTabSync() {
      // Store reference to handler for cleanup
      this.storageEventHandler = (e) => {
        if (e.key === "session_extended") {
          // Another tab extended the session - reset our timers
          this.handleSessionExtendedFromOtherTab();
        } else if (e.key === "session_logout") {
          // Another tab logged out - logout this tab too
          this.handleLogoutFromOtherTab();
        }
      };
      
      // Listen for storage events from other tabs
      window.addEventListener("storage", this.storageEventHandler);
    },

    /**
     * Broadcast session extension to other tabs via localStorage
     */
    broadcastSessionExtension() {
      try {
        localStorage.setItem("session_extended", Date.now().toString());
        // Remove immediately to allow future events
        setTimeout(() => {
          localStorage.removeItem("session_extended");
        }, 100);
      } catch (error) {
        console.error("Failed to broadcast session extension:", error);
      }
    },

    /**
     * Broadcast logout to other tabs via localStorage
     */
    broadcastLogout() {
      try {
        localStorage.setItem("session_logout", Date.now().toString());
        // Remove immediately to allow future events
        setTimeout(() => {
          localStorage.removeItem("session_logout");
        }, 100);
      } catch (error) {
        console.error("Failed to broadcast logout:", error);
      }
    },

    /**
     * Handle session extension from another tab
     */
    handleSessionExtendedFromOtherTab() {
      if (!this.isUserAuthenticated()) {
        return;
      }

      // Reset activity time, recalculate expiration, and hide warning if shown
      this.lastActivityTime = Date.now();
      this.calculateSessionExpirationTime();
      if (this.isWarningShown) {
        this.hideWarningModal();
      }
      this.resetAllTimers();
    },

    /**
     * Handle logout from another tab
     */
    async handleLogoutFromOtherTab() {
      // Immediately close popup
      this.hideWarningModal();
      this.isWarningShown = false;
      this.isExtendingSession = false;
      this.clearAllTimers();
      this.sessionExpirationTime = null;
      
      // Show logout toast notification
      if (this.$toast) {
        this.$toast.error("You have been logged out.", {
          position: "top-right",
        });
      }
      
      await this.$store.dispatch("auth/logout");
    },
  },
  beforeDestroy() {
    // Clean up all timers and event listeners
    this.clearAllTimers();
    const events = ["mousemove", "keydown", "mousedown", "touchstart", "scroll"];
    events.forEach((event) => {
      window.removeEventListener(event, this.resetIdleTimer);
    });
    // Remove storage event listener
    if (this.storageEventHandler) {
      window.removeEventListener("storage", this.storageEventHandler);
    }
    // Remove theme-related event listeners
    if (this.storageThemeHandler) {
      window.removeEventListener("storage", this.storageThemeHandler);
    }
    if (this.localStorageThemeHandler) {
      window.removeEventListener("companyInformationUpdated", this.localStorageThemeHandler);
    }
  }
};
</script>

